import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import FileUpload from '../../../common/form/elements/file-upload';
import FileUploadFileList from '../../../common/form/elements/file-upload-file-list';

class PipEposSubmissionsFormProofOfPurchase extends Component {
  handleFileUpload = (file) => {
    const { model, dispatch } = this.props;

    dispatch(actions.push(
      `${model}.pip_epos_proof_of_purchases_attributes`,
      { [Date.now()]: { persisted: false, proof_of_purchase: file } }
    ));
  };

  render() {
    const { model, formData } = this.props;

    return (
      <div>
        <FileUpload
          label="Please upload supporting evidence before validating the submission."
          model={`${model}.pip_epos_proof_of_purchases`}
          showFileNameInTextField
          onFileLoaded={this.handleFileUpload}
          multi
        />
        <FileUploadFileList
          data={formData.pip_epos_proof_of_purchases_attributes}
          model={`${model}.pip_epos_proof_of_purchases_attributes`}
          fileName="proof_of_purchase"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.admin_pip_epos_submissions
});

export default connect(mapStateToProps)(PipEposSubmissionsFormProofOfPurchase);
